import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { Globe } from 'lucide-react'

const LANGUAGES = [
  { code: 'zh-CN', label: '简体中文', nativeLabel: '简体中文' },
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'ja', label: '日本語', nativeLabel: '日本語' },
  { code: 'ko', label: '한국어', nativeLabel: '한국어' },
  { code: 'fr', label: 'Français', nativeLabel: 'Français' },
  { code: 'es', label: 'Español', nativeLabel: 'Español' },
  { code: 'de', label: 'Deutsch', nativeLabel: 'Deutsch' },
]

export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)

  const currentLang = LANGUAGES.find(l => i18n.language === l.code) || LANGUAGES[0]

  const switchLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode)
    setOpen(false)
  }

  return (
    <div
      className={`relative ${className}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-100/60 transition-all duration-200"
      >
        <Globe className="w-4 h-4" />
        <span>{currentLang.nativeLabel}</span>
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-1.5 w-36 bg-white rounded-xl shadow-lg border border-amber-100/60 py-1.5 z-50 overflow-hidden">
          {LANGUAGES.map(lang => (
            <button
              key={lang.code}
              onClick={() => switchLanguage(lang.code)}
              className={`w-full text-left flex items-center gap-2 px-4 py-2 text-sm transition-colors ${
                i18n.language === lang.code
                  ? 'text-[#6366f1] bg-[#6366f1]/5 font-medium'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
              }`}
            >
              <span className="w-6 text-center">{lang.nativeLabel.slice(0, 2)}</span>
              <span>{lang.label}</span>
              {i18n.language === lang.code && (
                <span className="ml-auto text-xs text-[#6366f1]">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
